/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    node, bool, object,
} from 'prop-types';
import SmartGiftWrapper from './SmartGiftWrapper';

const SmartGiftContainer = ({ children, isScriptLoadSucceed, brand = '1800flowers' }) => (
    <SmartGiftWrapper
        isScriptLoadSucceed={isScriptLoadSucceed}
        brand={brand}
    >{children}
    </SmartGiftWrapper>
);

SmartGiftContainer.propTypes = {
    isScriptLoadSucceed: bool,
    children: node,
    brand: object.isRequired,
};

SmartGiftContainer.defaultProps = {
    isScriptLoadSucceed: false,
    children: null,
};

export default SmartGiftContainer;
